import { Outlet } from 'react-router-dom';
import SideNav from './SideNav';

const Layout = () => {
  return (
    <>
      <SideNav />
      <div className="content-wrapper">
        <Outlet /> {/* This will render the matched child route */}
      </div>
    </>
  );
};

export default Layout;
